module.exports = __webpack_public_path__ + "media/images/common/icon-review-cbf2bd12091879180baef789013b57c5.png";